import React from "react";
import "./styles.css";
import heroImage from "../assets/hero.jpeg";
import Control from "./Control";
import SectionWithSwiper from "./SectionWithSwiper/SectionWithSwiper";
import Seguridad from "./Seguridad";
import ADTporque from "./ADTporque";
import Hero from "./Hero/Hero";
import NuevoSistema from "./NuevoSistema";
import Announcement from "./Announcement";
import WhatsappSection from "./WhatsappSection";

const Home = () => {
  return (
    <>
      <div className="home">
        <Announcement />
        <Hero heroImage={heroImage} />
        <Control />
        <SectionWithSwiper />
        <ADTporque />
        <Seguridad />
        <WhatsappSection />
        <NuevoSistema />
        {/* Simple Footer */}
        <footer className="footer">
          <div className="container-lg flex flexCol alignCenter">
            <p>{new Date().getFullYear()} Alarmita.com - ADT Agente Oficial</p>
          </div>
        </footer>
        {/* Sticky Bar */}
        <div className="sticky-bar">
          <a href="tel:08102203014">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path d="M14.89 23.654c-7.367 3.367-18.802-18.86-11.601-22.615l2.107-1.039 3.492 6.817-2.082 1.026c-2.189 1.174 2.37 10.08 4.609 8.994.091-.041 2.057-1.007 2.064-1.011l3.521 6.795c-.008.004-1.989.978-2.11 1.033zm-1.538-13.409l2.917.87c.223-.747.16-1.579-.24-2.317-.399-.739-1.062-1.247-1.808-1.469l-.869 2.916zm1.804-6.058c1.551.462 2.926 1.516 3.756 3.051.831 1.536.96 3.263.498 4.813l-1.795-.535c.325-1.091.233-2.306-.352-3.387-.583-1.081-1.551-1.822-2.643-2.146l.536-1.796zm.95-3.187c2.365.705 4.463 2.312 5.729 4.656 1.269 2.343 1.466 4.978.761 7.344l-1.84-.548c.564-1.895.406-4.006-.608-5.882-1.016-1.877-2.696-3.165-4.591-3.729l.549-1.841z" /></svg>
            Altas Telefónicas: 0810-220-3014</a>
        </div>
      </div>
    </>
  );
};

export default Home;
